//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BaseIcon',

  props: {
    icon: { type: [String, Object], default: null },
    color: { type: String, default: 'grey' },
    size: {
      type: [Number, String],
      default: 56,
    },
  },
};
